import type { AttestationConnectProof } from '@playcastdotio/Messaging';
import { createCanonicalJson, signCanonicalJson } from './machineIdSign';

/**
 * Build and AIK-sign a host_connect proof for AUTH_REQUEST after AUTH_CHALLENGE.
 * `issuedAt` is informational only (host clock may be wrong); realtime-api does
 * not use it for expiry — Redis challenge TTL is the nonce SoT.
 */
export async function buildHostConnectAttestationProof(input: {
  machineId: string;
  nonce: string;
  issuedAt?: number;
}): Promise<AttestationConnectProof> {
  const payload = {
    purpose: 'host_connect' as const,
    machineId: input.machineId,
    nonce: input.nonce,
    issuedAt: input.issuedAt ?? Date.now(),
  };
  const signature = await signCanonicalJson(createCanonicalJson(payload));
  return { payload, signature };
}
